var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoutIconWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3724 17.5H3.41406M3.41406 17.5L8.51823 13.125M3.41406 17.5L8.51823 21.875",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.625 10.2087C13.6425 7.03678 13.784 5.31887 14.904 4.19887C16.1858 2.91699 18.2479 2.91699 22.3721 2.91699H23.8304C27.956 2.91699 30.0181 2.91699 31.3 4.19887C32.5804 5.47928 32.5804 7.54283 32.5804 11.667V23.3337C32.5804 27.4578 32.5804 29.5214 31.3 30.8018C30.1785 31.9232 28.4606 32.0632 25.2887 32.0807M13.625 24.792C13.6425 27.9639 13.784 29.6818 14.904 30.8018C15.8387 31.738 17.1906 31.9903 19.4554 32.0589",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIconWhite);
export default __webpack_public_path__ + "static/media/logout-icon-white.09f5191d8937b85f204eeac70fb86af4.svg";
export { ForwardRef as ReactComponent };